import { useActiveStation } from '@app/core/stations/hooks/useActiveStation';
import { Station } from '@app/core/types/stations';

export function useAdoverlayEnabled(station: Station) {
  return Boolean(
    station.featuresConfig?.videoAnalysis?.enabled &&
    station.featuresConfig?.videoAnalysis?.adOverlays?.enabled,
  );
}

export function useAdoverlayEnabledForActiveStation() {
  const station = useActiveStation();
  return Boolean(
    station.featuresConfig?.videoAnalysis?.enabled &&
    station.featuresConfig?.videoAnalysis?.adOverlays?.enabled,
  );
}
